import { _, $, Radio, Foundation, moment, Datepicker } from "../../../../vendor";
import { Biscuit } from "../../../utils";
import Inboomai18n from "../../../utils/Inboomai18n";
import InboomaBaseView from "../../InboomaBaseView";

import TransactionsSidebarViewTpl from "../../../templates/myInbooma/TransactionsSidebarViewTpl.html";

export default InboomaBaseView.extend({
  template: TransactionsSidebarViewTpl,
  el: "#inb-c-sidebar",

  ui: {
    infoTooltip: ".fi-info",
    locationFilter: "#transactions-filter__location",
    paymentTypeFilter: "#transactions-filter__payment_type",
    paymentDayFilter: "#transactions-filter__payment_day",
    paymentDayBeginGte: "#transactions-filter__payment_begin_gte",
    paymentDayBeginGteFilterUnset: ".inbooma-select-box__reset_payment_begin_gte",
    paymentDayEndLte: "#transactions-filter__payment_end_lte",
    paymentDayEndLteFilterUnset: ".inbooma-select-box__reset_payment_end_lte",
    paymentDayFilterUnset: ".inbooma-select-box__reset_payment_day",
    sidebarToggle: "#toggle-left-bar",
  },

  events: {
    "change @ui.locationFilter": "_changeLocationFilter",
    "change @ui.paymentTypeFilter": "_changePaymentTypeFilter",
    "click @ui.paymentDayFilterUnset": "_unsetPaymentDayFilter",
    "click @ui.paymentDayBeginGteFilterUnset": "_unsetBeginGteFilter",
    "click @ui.paymentDayEndLteFilterUnset": "_unsetEndLteFilter",
    "focusout @ui.paymentDayFilter": "_changedManuallyPaymentDay",
    "click @ui.sidebarToggle": "_onToggleLeftBar",
  },

  templateContext() {
    return {
      _,
      moment,
      Biscuit,
      user_role: Biscuit.get("user.role"),
      managerHasLocations: this._managerHasLocations,
      locations: this._sortedLocations,
    };
  },

  _onToggleLeftBar(ev) {
    $("#inb-c-sidebar").toggleClass("open");
    $("html,body").scrollTop(0);
  },

  _managerHasLocations: [],

  _setPending() {
    this.collection.reset();
    this.collection._pending = true;
    console.log("COLL: ", this.collection);
  },

  _changedManuallyPaymentDay() {
    // For those kinda customers who do not use the unset-link, but
    // clear the field manually
    this._setPending();
    if (this.getUI("paymentDayFilter")[0].value === "") {
      this._unsetPaymentDayFilter();
    }
  },

  _unsetPaymentDayFilter(refetchCollection = true) {
    this._setPending();
    this.collection.removeFilter("payment_day", refetchCollection);
    this.getUI("paymentDayFilter")[0].value = this.t("payment_day");
    this.getUI("paymentDayFilterUnset")[0].classList.add("hide");
  },

  _changeLocationFilter() {
    this._setPending();
    this.collection.filterLocation(this.getUI("locationFilter")[0].value);
  },

  _changePaymentTypeFilter() {
    this._setPending();
    this.collection.filterPaymentType(this.getUI("paymentTypeFilter")[0].value);
  },

  _changePaymentDayFilter(date) {
    this._setPending();
    this.collection.filterPaymentDay(date);
    this.getUI("paymentDayFilterUnset")[0].classList.remove("hide");
  },

  _freezePaymentDayFilter() {
    this._unsetPaymentDayFilter(false);
    this.getUI("paymentDayFilter")[0].setAttribute("disabled", "disabled");
  },

  _unfreezePaymentDayFilter() {
    const activeFilters = this.collection._filterParams;

    if (
      typeof activeFilters["begin_gte"] === "undefined" &&
      typeof activeFilters["end_lte"] === "undefined"
    ) {
      this.getUI("paymentDayFilter")[0].removeAttribute("disabled");
    }
  },

  _changePaymentDayBeginGte(date) {
    this._setPending();
    this._freezePaymentDayFilter();
    this.collection.filterBeginGte(date);
    this.getUI("paymentDayBeginGteFilterUnset")[0].classList.remove("hide");
  },

  _unsetBeginGteFilter() {
    this._setPending();
    this.collection.removeFilter("begin_gte");
    this.getUI("paymentDayBeginGte")[0].value =
      this.getUI("paymentDayBeginGte")[0].getAttribute("placeholder");
    this.getUI("paymentDayBeginGteFilterUnset")[0].classList.add("hide");
    this._unfreezePaymentDayFilter();
  },

  _changePaymentDayEndLte(date) {
    this._setPending();
    this._freezePaymentDayFilter();
    this.collection.filterEndLte(date);
    this.getUI("paymentDayEndLteFilterUnset")[0].classList.remove("hide");
  },

  _unsetEndLteFilter() {
    this._setPending();
    this.collection.removeFilter("end_lte");
    this.getUI("paymentDayEndLte")[0].value =
      this.getUI("paymentDayEndLte")[0].getAttribute("placeholder");
    this.getUI("paymentDayEndLteFilterUnset")[0].classList.add("hide");
    this._unfreezePaymentDayFilter();
  },

  initialize() {
    const locations = Radio.channel("locations").request("get:data");

    this._sortedLocations = _.sortBy(locations.models, (location) => location.get("name"));

    let managerHasLocations = Biscuit.get("user.user_locations");

    if (managerHasLocations !== "") {
      // Auto-set and -filter first location of manager
      this._managerHasLocations = managerHasLocations.split(",");
      this.collection.filterLocation(this._managerHasLocations[0]);
    } else if (Biscuit.get("user.role") !== "user") {
      // For "Tagesabschluss" we require an active day + station (if is admin)

      if (Biscuit.get("user.role") !== "admin" && this._sortedLocations.length > 0) {
        this.collection.filterLocation(this._sortedLocations[0].get("id"));
      }

      // Initialize list with current date selected
      // Disabled as requested by #21333
      // this.collection.filterPaymentDay(new Date());
    } else if (Biscuit.get("user.role") === "user") {
      // Simply fetch unfiltered data
      // this.collection.resetFilters(true);
    }

    this.collection.resetFilters(true);

    this.render();
  },

  onRender() {
    const tooltip = this.getUI("infoTooltip");

    if (tooltip.length) {
      new Foundation.Tooltip(tooltip);
    }

    const that = this;

    this.paymentDayFilter = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("paymentDayFilter")[0],
      maxDate: new Date(),
      onSelect: (date) => {
        that._changePaymentDayFilter(date);
      },
    });

    this.beginGteFilter = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("paymentDayBeginGte")[0],
      maxDate: new Date(),
      onSelect: (date) => {
        that._changePaymentDayBeginGte(date);
      },
    });

    this.endLteFilter = new Datepicker({
      i18n: Inboomai18n.getPikadayI18n(),
      firstDay: 1, // monday
      field: this.getUI("paymentDayEndLte")[0],
      maxDate: new Date(),
      onSelect: (date) => {
        that._changePaymentDayEndLte(date);
      },
    });
    let managerHasLocations = Biscuit.get("user.user_locations");

    if (managerHasLocations !== "") {
      // Auto-set and -filter first location of manager
      this._managerHasLocations = managerHasLocations.split(",");
      this.getUI("locationFilter")[0].value = this._managerHasLocations[0];
      this.collection.filterLocation(this.getUI("locationFilter")[0].value);
    }
  },
});
